import React from 'react';
import moment from 'moment';

import { routes } from 'constants/config';
import { Card } from 'components/ui';
import Text from 'components/shared/Text';
import Badge from 'components/shared/Badge';

const FeedbackRequestCard = props => {
  const { feedbackRequest } = props;
  const { requester, scenario, requestDate, attemptId } = feedbackRequest;
  const formattedDate = moment(requestDate).format('LL');
  const fromNowDays = moment(requestDate).fromNow(true);
  const daysAwaitingFeedback = `${fromNowDays} ${t(
    'practice.on_demand_practice.previous_attempts.feedback.time_awaiting_feedback',
  )}`;
  return (
    <div className="w-half m-w-fill pr-24 pb-24">
      <Card
        url={routes.ON_DEMAND_PRACTICE.LEARNING.ATTEMPTS.GIVE_FEEDBACK(
          scenario.id,
          attemptId,
        )}
        className="w-fill d-b"
      >
        <Card.Content padding="medium">
          <div className="d-f fd-c jc-sb h-100p ov-h">
            <div className="d-fi jc-sb w-fill ai-fs">
              <Text
                lines={2}
                className="ff-ss fw-b f-smooth mb-8 mt-8 c-navy-darker fz-18"
              >
                {scenario.title}
              </Text>
              <Badge className="bdrs-small ls-u p-3-10 fz-12 tt-n bg-gray-light c-navy-darker mt-10">
                {daysAwaitingFeedback}
              </Badge>
            </div>
            <div className="d-f jc-sb w-fill">
              <Text lines={1} className="jc-s w-half c-navy d-fi fz-16">
                {requester}
              </Text>
              <p className="jc-e c-navy w-half d-fi">{formattedDate}</p>
            </div>
          </div>
        </Card.Content>
      </Card>
    </div>
  );
};
export default FeedbackRequestCard;
